export const SITE = {
  name: "A+GLASS Pare-Brise HAGUENAU",
  short: "A+ Glass Haguenau",
  tagline: "Spécialiste Pare-Brise, Vitrage et Éclairage tous véhicules",
  street: "101A Route de Marienthal",
  zip: "67500",
  city: "Haguenau",
  phone: "03 88 93 16 73",
  phoneIntl: "+33388931673",
  phoneSchema: "+33 3 88 93 16 73",
  email: "haguenau@aplusglass.com",
  officialUrl: "https://www.aplusglass.com/centre-haguenau-67500/",
  mapsDir: "https://www.google.com/maps/dir/?api=1&destination=A%2BGLASS+Pare-Brise+HAGUENAU+101A+Route+de+Marienthal+67500+Haguenau",
  mapsEmbed: "https://www.google.com/maps?q=A%2BGLASS+Pare-Brise+HAGUENAU,+101A+Route+de+Marienthal,+67500+Haguenau&output=embed",
};

export const TEL = `tel:${SITE.phoneIntl}`;

// [day index 0=Sunday], minutes from midnight
export const HOURS = [
  { day: "Lundi", d: 1, open: "08:30", close: "18:00" },
  { day: "Mardi", d: 2, open: "08:30", close: "18:00" },
  { day: "Mercredi", d: 3, open: "08:30", close: "18:00" },
  { day: "Jeudi", d: 4, open: "08:30", close: "18:00" },
  { day: "Vendredi", d: 5, open: "08:30", close: "18:00" },
  { day: "Samedi", d: 6, open: "08:30", close: "12:00" },
  { day: "Dimanche", d: 0, open: null, close: null },
];

const toMin = (t) => { const [h, m] = t.split(":").map(Number); return h * 60 + m; };

export function parisNow() {
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Paris", weekday: "short", hour: "2-digit", minute: "2-digit", hour12: false }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(get("weekday"));
  return { day, minutes: Number(get("hour")) % 24 * 60 + Number(get("minute")) };
}

export function openStatus() {
  const { day, minutes } = parisNow();
  const today = HOURS.find((h) => h.d === day);
  if (today?.open && minutes >= toMin(today.open) && minutes < toMin(today.close)) {
    return { open: true, label: `Ouvert · ferme à ${today.close.replace(":", "h")}` };
  }
  for (let i = 0; i < 7; i += 1) {
    const d = (day + i) % 7;
    const h = HOURS.find((x) => x.d === d);
    if (h?.open && (i > 0 || minutes < toMin(h.open))) {
      const when = i === 0 ? "aujourd'hui" : i === 1 ? "demain" : h.day.toLowerCase();
      return { open: false, label: `Fermé · ouvre ${when} à ${h.open.replace(":", "h")}` };
    }
  }
  return { open: false, label: "Fermé" };
}

export const NAV = [
  { to: "/remplacement-pare-brise-haguenau", label: "Pare-brise" },
  { to: "/reparation-impact-pare-brise-haguenau", label: "Impact" },
  { to: "/vitrage-automobile-haguenau", label: "Vitrage" },
  { to: "/calibration-camera-adas-haguenau", label: "Calibration ADAS" },
  { to: "/renovation-optiques-phares-haguenau", label: "Rénovation optiques" },
  { to: "/pare-brise-domicile-haguenau", label: "À domicile" },
  { to: "/assurance-pare-brise-haguenau", label: "Assurances" },
];

export const SERVICE_OPTIONS = ["Pare-brise", "Impact", "Vitrage automobile", "Lunette arrière", "Vitre latérale", "Calibration ADAS", "Rénovation optiques", "Intervention à domicile", "Autre"];
